import { gql } from '@apollo/client';

export const LIST_PICKUP_CITIES = gql`
  query ListPickupCities($warehouseId: Long!) {
    listPickupCities(warehouseId: $warehouseId)
  }
`;

export interface ListPickupCitiesResponse {
    listPickupCities: string[];
}
